// extracted by mini-css-extract-plugin
export default {"header":"_-_-record-it-components-src-modal-ConfirmModalHeader-__header"};